"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unifyEquation = void 0;
const check_1 = require("../../check");
const ctx_1 = require("../../ctx");
const evaluate_1 = require("../../evaluate");
const infer_1 = require("../../infer");
const unify_1 = require("../../unify");
function unifyEquation(mod, ctx, equation) {
    switch (equation["@kind"]) {
        case "EquationUnifyTyped": {
            const env = (0, ctx_1.ctxToEnv)(ctx);
            const type = (0, evaluate_1.evaluate)(env, (0, check_1.checkType)(mod, ctx, equation.type));
            const left = (0, evaluate_1.evaluate)(env, (0, check_1.check)(mod, ctx, equation.left, type));
            const right = (0, evaluate_1.evaluate)(env, (0, check_1.check)(mod, ctx, equation.right, type));
            (0, unify_1.unify)(mod, ctx, type, left, right);
            return;
        }
        case "EquationUnify": {
            const leftInferred = (0, infer_1.inferOrUndefined)(mod, ctx, equation.left);
            const rightInferred = (0, infer_1.inferOrUndefined)(mod, ctx, equation.right);
            if (leftInferred !== undefined && rightInferred !== undefined) {
                const leftType = leftInferred.type;
                const rightType = rightInferred.type;
                (0, unify_1.unifyType)(mod, ctx, leftType, rightType);
                const type = leftType;
                const env = (0, ctx_1.ctxToEnv)(ctx);
                const left = (0, evaluate_1.evaluate)(env, leftInferred.core);
                const right = (0, evaluate_1.evaluate)(env, rightInferred.core);
                (0, unify_1.unify)(mod, ctx, type, left, right);
                return;
            }
            if (leftInferred !== undefined) {
                const type = leftInferred.type;
                const env = (0, ctx_1.ctxToEnv)(ctx);
                const left = (0, evaluate_1.evaluate)(env, leftInferred.core);
                const rightCore = (0, check_1.check)(mod, ctx, equation.right, type);
                const right = (0, evaluate_1.evaluate)(env, rightCore);
                (0, unify_1.unify)(mod, ctx, type, left, right);
                return;
            }
            if (rightInferred !== undefined) {
                const type = rightInferred.type;
                const env = (0, ctx_1.ctxToEnv)(ctx);
                const leftCore = (0, check_1.check)(mod, ctx, equation.left, type);
                const left = (0, evaluate_1.evaluate)(env, leftCore);
                const right = (0, evaluate_1.evaluate)(env, rightInferred.core);
                (0, unify_1.unify)(mod, ctx, type, left, right);
                return;
            }
            // NOTE Let the `infer` error
            (0, infer_1.infer)(mod, ctx, equation.left);
            (0, infer_1.infer)(mod, ctx, equation.right);
            return;
        }
    }
}
exports.unifyEquation = unifyEquation;
//# sourceMappingURL=unifyEquation.js.map